export default __webpack_public_path__ + "57aa4ea.png";